// src/services/ingredientService.ts
import axios from 'axios';

const API_URL = 'https://hellogassy-backend.onrender.com/api/ingredients'; // adapte si besoin

export const ingredientService = {
  // 🔹 Récupérer tous les ingrédients
  getAllIngredients: async () => {
    const response = await axios.get(API_URL);
    return response.data;
  },

  // 🔹 Récupérer un ingrédient par ID
  getIngredientById: async (id: string) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  },

  // 🔹 Créer un ingrédient (admin)
  createIngredient: async (ingredientData: any, token: string) => {
    const response = await axios.post(API_URL, ingredientData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
    });
    return response.data;
  },

  // 🔹 Mettre à jour un ingrédient (admin)
  updateIngredient: async (id: string, ingredientData: any, token: string) => {
    const response = await axios.put(`${API_URL}/${id}`, ingredientData, {
      headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
      },
    });
    return response.data;
  },

  // 🔹 Supprimer un ingrédient (admin)
  deleteIngredient: async (id: string, token: string) => {
    const response = await axios.delete(`${API_URL}/${id}`, {
      headers: {
       Authorization: `Bearer ${localStorage.getItem('token')}`
      },
    });
    return response.data;
  },
};

